module.exports = __webpack_public_path__ + "static/media/naga_t.0033ce14.png";